// add csv to same directory as this file
import data from './data.csv';
import Element from './element.js';
import Legend from './legend.js';

import { range, max } from 'd3-array';
import { rgb } from 'd3-color';
import { interpolateYlOrRd } from 'd3-scale-chromatic';
import { scaleThreshold } from 'd3-scale';

import { initFrameAndPoll } from '@newswire/frames';

const d3 = {
  range, max,
  rgb,
  scaleThreshold,
  interpolateYlOrRd,
};

// LAT uses frames, not pym
const frames = {
  initFrameAndPoll
};

const docReady = function(func) {
  // https://stackoverflow.com/a/9899701
    // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(func, 1);
  } else {
    document.addEventListener('DOMContentLoaded', func);
  }
};

const debounce = function(func, wait, immediate) {
  // https://davidwalsh.name/javascript-debounce-function
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

const statuses = ['in-custody', 'other'];


const children = data.map((d, i) => {
  d.highlight = i == 226 ? 1 : 0;
  d.days = d.days_in_custody;
  d.year = d.year_placed;
  d.status =  d.in_custody ? 'in-custody' : 'other';
  d.statusOrder = d.in_custody ? 0 : 1;
  return d;
}).sort((a,b) => {
  // sort by days
  return a.days - b.days;
}).sort((a,b) => {
  return a.statusOrder - b.statusOrder;
});

let tooltipShownOnce = false;

docReady(() => {
  const numColors = 5;
  const domains = d3.range(numColors).map(i => Math.round(365 * (i + 2)/2));
  const max = d3.max(children, d => d.days);

  const skippedColors = 1;
   // the first color is too light to read so cut them off

  const numSwatches = numColors + skippedColors + 1; // 1 is needed to get the 3+ year color

  let range = [];
  for (let i = 0; i < numSwatches; ++i) {
     if (i >= skippedColors) {
      range.push(d3.rgb(d3.interpolateYlOrRd(i / (numSwatches - 1))).hex());
     }
  }

  const colorScale = d3.scaleThreshold(domains, range);

  const legend = new Legend({
    threshold: colorScale,
    max: max
  }).render();

  document.getElementById('scale').append(legend);

  const interactiveGroup = document.getElementById('interactive'),
    tooltip = document.getElementById('tooltip'),
    tooltipContents = document.getElementById('tooltip-sentence');

  const removeDotBorders = () => {
    Array.from(document.getElementsByClassName('dot')).forEach(el => { el.style.borderColor = '#fff'; })
  };

  const closeTooltip = function(e) {
    e.preventDefault();
    removeDotBorders();
    tooltip.className = 'tooltip hidden';
  };

  // need both touchstart and click for mobile, otherwise tooltip doesn't always close correctly
  tooltip.addEventListener('touchstart', closeTooltip);
  tooltip.addEventListener('click', closeTooltip);

  // create a div element for each child and attach event listeners
  children.forEach((d, i) => {
    const groupContainer = document.getElementById(`interactive-${ d.year }`);

    const dot = new Element('div', {
      class: `dot`,
      innerHTML: `<span class='sr-only'>${ d.sentence }</span>`
    });
    
    dot.style.borderColor = '#fff';

    if (d.status === 'in-custody') {
      dot.style.backgroundColor = '#666';
    } else {
      dot.style.backgroundColor = colorScale(d.days);
    }
    groupContainer.append(dot);

    const showTooltip = e => {
      removeDotBorders();

      dot.style.borderColor = '#000';

      const fillPositionTooltip = () => {
        // fill out tooltip
        tooltipContents.innerHTML = d.sentence;

        // get height and width of interactive container to position tooltip
        const interactiveWidth = interactiveGroup.clientWidth,
          interactiveHeight = interactiveGroup.clientHeight,
          tooltipWidth = tooltip.clientWidth,
          tooltipHeight = tooltip.clientHeight,
          dotRect = dot.getBoundingClientRect(),
          buffer = window.innerWidth < 450 ? 5 * 2 : 7 * 2;

        // calculate position of tooltip based on where mouse is (so tooltip won't get cut off)
        const tooltipX = (dotRect.x < interactiveWidth/2) ? dotRect.x + buffer : dotRect.x - tooltipWidth - buffer/2,
          tooltipY = dotRect.y < interactiveGroup.offsetTop + interactiveHeight/2 ? dotRect.y + buffer : dotRect.y - tooltipHeight - buffer/2;

        // show and position tooltip
        tooltip.style.left = `${ tooltipX }px`;
        tooltip.style.top = `${ tooltipY }px`;
        tooltip.className = 'tooltip';
      };

      fillPositionTooltip();
      if (!tooltipShownOnce) {
        setTimeout(() => {
          fillPositionTooltip();
        }, 100)
        tooltipShownOnce = true;
      }

    };

    dot.addEventListener('mouseover', showTooltip);

    // hide tooltip on mouseout
    dot.addEventListener('mouseout', e => {
      closeTooltip(e);
      dot.style.borderColor = '#fff';
    });
    // show 1 kid
    if (d.highlight) {
      dot.style.borderColor = '#000';
      showTooltip();
    }
  });

  const methodology = document.getElementById('methodology'),
    methodologyOpen = document.getElementById('methodology-open'),
    methodologyClose = document.getElementById('methodology-close');

  methodologyOpen.addEventListener('click', () => {
    methodology.className = 'methodology';
    methodologyOpen.className = 'link hidden';
    pymChild.sendHeight();
  });
  methodologyClose.addEventListener('click', () => {
    methodology.className = 'methodology hidden';
    methodologyOpen.className = 'link';
    pymChild.sendHeight();
  });

  const pymChild = new pym.Child();
  pymChild.sendHeight();
  
  frames.initFrameAndPoll();

  const resizeFn = debounce(() => {
    // resize code goes here
    pymChild.sendHeight();
  }, 450);
  window.addEventListener('resize', resizeFn);
});
